import { useTranslation } from "react-i18next";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const Clients = ({ data }) => {
	const { t } = useTranslation();

	return (
		<div className="clients">
			<p>{t("Our partners")}</p>
			<div className="mt-3">
				<Swiper
					slidesPerView={3}
					spaceBetween={20}
					modules={[Autoplay]}
					autoplay={{
						delay: 2000,
						disableOnInteraction: false,
					}}
					loop={true}
					breakpoints={{
						640: {
							slidesPerView: 3,
							spaceBetween: 20,
						},
						768: {
							slidesPerView: 4,
							spaceBetween: 25,
						},
						1024: {
							slidesPerView: 5,
							spaceBetween: 30,
						},
						1440: {
							slidesPerView: 6,
							spaceBetween: 30,
						},
					}}
					style={{ direction: "ltr" }}
					className="mySwiper">
					{data?.map((res, index) => {
						return (
							<SwiperSlide key={index}>
								<img src={res?.image} alt="client" className="w-100" />
							</SwiperSlide>
						);
					})}
				</Swiper>
			</div>
		</div>
	);
};
export default Clients;
